import { AxiosResponse, AxiosRequestConfig } from 'axios';
import client from '../client';
import { Tokens } from 'api/models';
import { RegisterPayload } from 'api/models/payload';

export function register(
    userData: RegisterPayload,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<Tokens>> {
    return client.post<Tokens>(`/register-client`, userData, customConfig);
}
